const _public = {};

_public.appendSearchParam = (baseURL, param) => {
  const searchChar = baseURL.includes('?') ? '&' : '?';
  return [baseURL, param].join(searchChar);
};

_public.getSearchParams = () => {
  return Object.fromEntries(new URLSearchParams(window.location.search).entries());
};

export default _public;
